import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Persona } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField, FormikDatePicker } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import useUserCanWriteAndDelete from "../../hooks/permissions"

export default function PersonaForm({ item, save, ref }: FormInDialogProps<Persona>) {
  const { t } = useTranslation()
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const initialValues = useMemo(() => {
    return {
      nome: "",
      data_nascita: undefined,
      data_morte: undefined,
      biografia_it: "",
      biografia_en: "",
      note: "",
      ...(item ?? {}),
    }
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome: yup.string().required().label(t("donatore.nome")),
      }),
    [t],
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Persona).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="nome"
                  label={t("persona.nome")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={6}>
                <Field
                  component={FormikDatePicker}
                  name="data_nascita"
                  label={t("persona.data_nascita")}
                  required
                  margin="dense"
                  type="date"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={6}>
                <Field
                  component={FormikDatePicker}
                  name="data_morte"
                  label={t("persona.data_morte")}
                  required
                  margin="dense"
                  type="date"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  multiline
                  minRows={6}
                  name="biografia_it"
                  label={t("persona.biografia_it")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  multiline
                  minRows={6}
                  name="biografia_en"
                  label={t("persona.biografia_en")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  multiline
                  minRows={6}
                  name="note"
                  label={t("persona.note")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
